import api from "../utils/api";

export const addAccountBalance = async (
  value,
  category,
  reason,
  description,
  consumer_unit_id,
) =>
  await api.post(
    process.env.VUE_APP_UPDATE_CONSUMER_UNIT +
      consumer_unit_id +
      "/creditBalanceTransaction",
    {
      value: value,
      category: category,
      reason: reason,
      description: description,
      type: "credit",
    },
  );
